// src/components/sections/ContactSection.js
import { useLang } from '../../i18n/LanguageContext';
import { useSiteConfig } from '../../context/SiteConfigContext';
import styles from './ContactSection.module.css';

export default function ContactSection() {
  const { t, ui } = useLang();
  const { config } = useSiteConfig();

  const infoItems = [
    { icon: '💬', label: ui('آیدی تلگرام', 'Telegram ID'),   value: config.telegram_id },
    { icon: '📱', label: ui('آیدی ایتا',   'Eitaa ID'),       value: config.eitaa_id },
    { icon: '⏰', label: ui('ساعت پاسخگویی', 'Working Hours'), value: t(config, 'working_hours') },
    { icon: '📦', label: ui('زمان تحویل',  'Delivery Time'),  value: t(config, 'delivery_time') },
    { icon: '🕯️', label: ui('زمان آماده‌سازی', 'Prep. Time'), value: t(config, 'preparation_time') },
  ];

  return (
    <section className={styles.section} id="contact">
      <div className={styles.inner}>

        <div className={styles.header}>
          <div className="tag-badge">{ui('✦ ارتباط با ما', '✦ Contact Us')}</div>
          <h2 className="grad-text" style={{ fontSize: 'clamp(1.8rem,4vw,2.5rem)', fontWeight: 800 }}>
            {ui('سفارش و پشتیبانی', 'Order & Support')}
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: 2, marginTop: '0.5rem', fontSize: '0.92rem' }}>
            {ui(
              'برای سفارش، استعلام قیمت یا هر سوالی از طریق پیام‌رسان‌های زیر با ما در تماس باشید',
              'For orders, price inquiries or any questions, contact us via the messengers below'
            )}
          </p>
        </div>

        <div className={styles.buttons}>
          <a
            href={`https://t.me/${config.telegram_id?.replace('@', '')}`}
            target="_blank"
            rel="noreferrer"
            className={styles.telegramBtn}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8l-1.68 7.92c-.12.56-.46.7-.92.44l-2.54-1.88-1.24 1.19c-.14.14-.26.26-.52.26l.18-2.56 4.68-4.23c.2-.18-.04-.28-.32-.1L8.88 14.68l-2.48-.77c-.54-.17-.55-.54.12-.8l9.68-3.73c.45-.16.84.11.44.82z"/>
            </svg>
            {ui('تلگرام کیوت کندل', 'Cute Candels Telegram')}
          </a>
          <a
            href={`https://eitaa.com/${config.eitaa_id?.replace('@', '')}`}
            target="_blank"
            rel="noreferrer"
            className={styles.eitaaBtn}
          >
            <svg width="22" height="22" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" fill="#1a0a2e"/>
              <path d="M7 12l3.5 3.5L17 8.5" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {ui('ایتا کیوت کندل', 'Cute Candels Eitaa')}
          </a>
        </div>

        <div className={styles.infoGrid}>
          {infoItems.map(({ icon, label, value }) => (
            <div key={label} className={styles.infoItem}>
              <span className={styles.infoIcon}>{icon}</span>
              <div>
                <div className={styles.infoLabel}>{label}</div>
                <div className={styles.infoValue}>{value}</div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
